import { useEffect, useRef, useState } from 'react';

const POLL_INTERVAL_MS = 5 * 60 * 1000;

async function fetchBuildTime(): Promise<string | null> {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const data: { buildTime?: string } = await res.json();
    return data.buildTime ?? null;
  } catch {
    return null;
  }
}

export function useVersionCheck(): { updateAvailable: boolean } {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const initialBuildTime = useRef<string | null>(null);

  useEffect(() => {
    fetchBuildTime().then((buildTime) => {
      initialBuildTime.current = buildTime;
    });

    const interval = setInterval(async () => {
      const buildTime = await fetchBuildTime();
      if (
        buildTime !== null &&
        initialBuildTime.current !== null &&
        buildTime !== initialBuildTime.current
      ) {
        setUpdateAvailable(true);
        clearInterval(interval);
      }
    }, POLL_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);

  return { updateAvailable };
}
